// extracted by mini-css-extract-plugin
module.exports = {"item":"P_c3","item__image":"P_c4","item__title":"P_dn","item__counter":"P_dp","item__active":"P_dq"};